import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=285549f2&"
import script from "./Menu.vue?vue&type=script&setup=true&lang=js&"
export * from "./Menu.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=285549f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports